import React, { useState } from 'react';
import { 
  HeroSection,
  BlogCategoriesSection,
  FeaturedPostSection,
  BlogPostsGridSection,
  PopularTopicsSection
} from '../components';

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const blogPosts = [
    {
      id: 1,
      title: '10 Essential SEO Strategies for 2024',
      excerpt: 'Découvrez les dernières techniques SEO qui aideront votre site web à mieux se classer dans les moteurs de recherche et à générer plus de trafic organique. Dans cet article complet, nous explorons les stratégies éprouvées qui fonctionnent en 2024, incluant l\'optimisation technique, le contenu de qualité, et les nouvelles tendances du référencement.',
      category: 'SEO Tips',
      author: 'Jinit Mungra',
      date: '2024-01-15',
      readTime: '5 min read',
      image: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      featured: true,
      views: 2340,
      shares: 156,
      tags: ['SEO', 'Référencement', 'Marketing Digital']
    },
    {
      id: 2,
      title: 'The Future of Digital Marketing: AI and Automation',
      excerpt: 'Explorez comment l\'intelligence artificielle et l\'automatisation révolutionnent les stratégies de marketing digital et l\'engagement client. Nous analysons les outils d\'IA les plus récents, les plateformes d\'automatisation, et comment les intégrer efficacement dans votre stratégie marketing pour maximiser vos résultats.',
      category: 'Digital Marketing',
      author: 'Meet Desai',
      date: '2024-01-12',
      readTime: '7 min read',
      image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      featured: false,
      views: 1890,
      shares: 98,
      tags: ['IA', 'Automatisation', 'Marketing Digital']
    },
    {
      id: 3,
      title: 'Building Responsive Websites: Best Practices',
      excerpt: 'Apprenez les techniques essentielles pour créer des sites web qui ont l\'air parfaits et fonctionnent parfaitement sur tous les appareils. Ce guide complet couvre les principes du design responsive, les frameworks modernes, et les meilleures pratiques pour assurer une expérience utilisateur optimale sur mobile, tablette et desktop.',
      category: 'Web Development',
      author: 'Ansh Kared',
      date: '2024-01-10',
      readTime: '6 min read',
      image: 'https://images.unsplash.com/photo-1547658719-da2b51169166?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      featured: false,
      views: 1650,
      shares: 87,
      tags: ['Développement Web', 'Responsive Design', 'UX/UI']
    },
    {
      id: 4,
      title: 'Design Trends That Will Dominate 2024',
      excerpt: 'Restez à la pointe avec ces tendances de design émergentes qui façonneront le paysage numérique en 2024. Nous explorons les nouvelles directions créatives, les couleurs tendance, les typographies modernes, et comment intégrer ces éléments dans vos projets pour créer des designs contemporains et engageants.',
      category: 'Design Trends',
      author: 'Jinit Mungra',
      date: '2024-01-08',
      readTime: '4 min read',
      image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      featured: false,
      views: 2100,
      shares: 134,
      tags: ['Design', 'Tendances', 'Créativité']
    },
    {
      id: 5,
      title: 'Social Media Marketing: A Complete Guide',
      excerpt: 'Maîtrisez l\'art du marketing sur les réseaux sociaux avec notre guide complet couvrant toutes les plateformes majeures et stratégies. Découvrez comment créer du contenu engageant, développer votre audience, mesurer vos performances, et optimiser vos campagnes pour maximiser votre retour sur investissement sur chaque plateforme.',
      category: 'Digital Marketing',
      author: 'Meet Desai',
      date: '2024-01-05',
      readTime: '8 min read',
      image: 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      featured: false,
      views: 2750,
      shares: 201,
      tags: ['Réseaux Sociaux', 'Marketing', 'Stratégie']
    },
    {
      id: 6,
      title: 'Performance Optimization for Modern Websites',
      excerpt: 'Apprenez comment optimiser votre site web pour la vitesse, les performances et l\'expérience utilisateur dans le paysage numérique concurrentiel d\'aujourd\'hui. Ce guide détaillé couvre l\'optimisation des images, la mise en cache, la compression, et les techniques avancées pour créer des sites web ultra-rapides.',
      category: 'Web Development',
      author: 'Ansh Kared',
      date: '2024-01-03',
      readTime: '6 min read',
      image: 'https://images.unsplash.com/photo-1551650975-87deedd944c3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
      featured: false,
      views: 1920,
      shares: 112,
      tags: ['Performance', 'Optimisation', 'Vitesse']
    }
  ];

  return (
    <div className="blog-page">
      {/* Hero Section */}
      <HeroSection
        title="GrowthVibe Blog"
        description="Découvrez nos insights, conseils et stratégies pour faire grandir votre entreprise dans le monde numérique. Des articles experts sur le marketing digital, le développement web, et les tendances technologiques."
        showGradient={true}
        heroImage="https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80"
        heroImageAlt="Blog Content and Digital Marketing Insights"
        layout="centered"
      />

      {/* Blog Stats Section */}
      <section className="py-4 bg-light">
        <div className="container">
          <div className="row text-center">
            <div className="col-md-3 col-6 mb-3">
              <div className="h4 text-primary mb-1">{blogPosts.length}+</div>
              <div className="small text-muted">Articles Publiés</div>
            </div>
            <div className="col-md-3 col-6 mb-3">
              <div className="h4 text-primary mb-1">{blogPosts.reduce((sum, post) => sum + (post.views || 0), 0).toLocaleString()}</div>
              <div className="small text-muted">Vues Total</div>
            </div>
            <div className="col-md-3 col-6 mb-3">
              <div className="h4 text-primary mb-1">{blogPosts.reduce((sum, post) => sum + (post.shares || 0), 0)}</div>
              <div className="small text-muted">Partages</div>
            </div>
            <div className="col-md-3 col-6 mb-3">
              <div className="h4 text-primary mb-1">4</div>
              <div className="small text-muted">Catégories</div>
            </div>
          </div>
        </div>
      </section>

      {/* Categories Filter */}
      <BlogCategoriesSection 
        selectedCategory={selectedCategory} 
        onCategoryChange={setSelectedCategory} 
      />

      {/* Featured Post */}
      <FeaturedPostSection 
        selectedCategory={selectedCategory} 
        blogPosts={blogPosts} 
      />

      {/* Blog Posts Grid */}
      <BlogPostsGridSection 
        selectedCategory={selectedCategory} 
        blogPosts={blogPosts} 
      />

      {/* Popular Topics */}
      <PopularTopicsSection />
    </div>
  );
};

export default Blog;
